(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
/* Mobile gallery */
(function() {
  document.querySelectorAll('[data-gallery-mobile]').forEach(function(gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var ticks = gallery.querySelectorAll('[data-dot-index]');
    var total = parseInt(gallery.dataset.total, 10);
    var currentIndex = 0;

    if (!track || total <= 1) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          var idx = parseInt(entry.target.dataset.slideIndex, 10);
          if (idx !== currentIndex) {
            currentIndex = idx;
            ticks.forEach(function(tick) {
              tick.classList.toggle(
                'product-gallery-mobile__tick--active',
                parseInt(tick.dataset.dotIndex, 10) === idx
              );
            });
          }
        }
      });
    }, {
      root: track,
      threshold: 0.5
    });

    track.querySelectorAll('[data-slide-index]').forEach(function(slide) {
      observer.observe(slide);
    });

    ticks.forEach(function(tick) {
      tick.addEventListener('click', function() {
        var idx = parseInt(this.dataset.dotIndex, 10);
        var targetSlide = track.children[idx];
        if (targetSlide) {
          track.scrollTo({
            top: targetSlide.offsetTop - track.offsetTop,
            behavior: 'smooth'
          });
        }
      });
    });
  });
})();

/* Bi-directional sticky (H&M style) */
(function() {
  if (window.innerWidth < 750) return;

  var details = document.querySelector('.product-information--has-gallery .product-details.sticky-content--desktop');
  if (!details) return;

  /* Remover a classe para o theme JS do Horizon não sobrescrever o top */
  details.classList.remove('sticky-content--desktop');
  details.classList.add('sticky-content--custom');

  var lastScroll = window.scrollY;
  var currentTop = 0;
  var ticking = false;
  var initialized = false;

  function getHeaderHeight() {
    var header = document.querySelector('.shopify-section-header, header');
    if (!header) return 80;
    var rect = header.getBoundingClientRect();
    var style = window.getComputedStyle(header);
    if (style.position === 'sticky' || style.position === 'fixed') {
      return header.offsetHeight;
    }
    return Math.max(0, rect.bottom);
  }

  function update() {
    var scrollY = window.scrollY;
    var delta = scrollY - lastScroll;
    var headerH = getHeaderHeight();
    var viewportH = window.innerHeight;
    var detailsH = details.offsetHeight;
    var gap = 20;

    if (!initialized) {
      currentTop = headerH + gap;
      initialized = true;
    }

    if (detailsH <= viewportH - headerH - gap) {
      currentTop = headerH + gap;
    } else {
      var minTop = viewportH - detailsH - gap;
      var maxTop = headerH + gap;
      currentTop = currentTop - delta;
      currentTop = Math.max(minTop, Math.min(maxTop, currentTop));
    }

    details.style.position = 'sticky';
    details.style.top = currentTop + 'px';
    details.style.alignSelf = 'flex-start';
    lastScroll = scrollY;
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  /* Recalcular em resize */
  window.addEventListener('resize', function() {
    if (window.innerWidth < 750) {
      details.style.position = '';
      details.style.top = '';
      return;
    }
    initialized = false;
    lastScroll = window.scrollY;
    update();
  });

  /* Recalcular quando o conteúdo muda de altura (dropdowns) */
  var prevDetailsH = details.offsetHeight;
  var scrolling = false;
  var scrollTimer = null;

  var resizeObserver = new ResizeObserver(function() {
    var viewportH = window.innerHeight;
    var detailsH = details.offsetHeight;
    var headerH = getHeaderHeight();
    var gap = 20;
    var heightDelta = detailsH - prevDetailsH;
    prevDetailsH = detailsH;

    if (Math.abs(heightDelta) < 2) return;

    if (detailsH <= viewportH - headerH - gap) {
      currentTop = headerH + gap;
    } else if (heightDelta > 0) {
      var minTop = viewportH - detailsH - gap;
      var maxTop = headerH + gap;
      currentTop = Math.max(minTop, currentTop - heightDelta);
      currentTop = Math.max(minTop, Math.min(maxTop, currentTop));
    } else if (heightDelta < 0) {
      var minTop = viewportH - detailsH - gap;
      var maxTop = headerH + gap;
      currentTop = Math.max(minTop, Math.min(maxTop, currentTop));
    }

    if (!scrolling) {
      details.style.transition = 'top 0.3s ease';
    }
    details.style.top = currentTop + 'px';
    setTimeout(function() { details.style.transition = ''; }, 350);
  });
  resizeObserver.observe(details);

  window.addEventListener('scroll', function() {
    scrolling = true;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() { scrolling = false; }, 100);
  }, { passive: true });

  /* Posição inicial */
  requestAnimationFrame(update);
})();

/* Accordion exclusivo — só um dropdown aberto de cada vez */
(function() {
  var accordion = document.querySelector('.accordion');
  if (!accordion) return;

  var allDetails = accordion.querySelectorAll('details');

  allDetails.forEach(function(detail) {
    detail.addEventListener('toggle', function() {
      if (this.open) {
        allDetails.forEach(function(other) {
          if (other !== detail && other.open) {
            other.removeAttribute('open');
          }
        });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
